module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {}, [(!_vm.pathFlag) ? _c('div', {
    staticClass: "icon_out_wrap fr",
    on: {
      "click": _vm.logout
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/report/icon_out.png"
    }
  })]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap fl"
  }, [_c('img', {
    attrs: {
      "src": "/static/report/logo_zyw.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title fl"
  }, [_c('p', [_vm._v("移宇在线报表系统")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2da3918c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportHeaderTwo.vue
// module id = 741
// module chunks = 1